import React from "react";
import { Alert, AlertTitle, Box, Button, CircularProgress } from "@material-ui/core";
import { Navigate, Outlet, useLocation} from "react-router-dom";
import Cookies from "universal-cookie";
import axios from "axios";
import { config } from "../../config/config";
import { removeAuthCookie } from "../../config/config";

const ProtectedRoutes = () => {
  const location = useLocation();
  const [attempt, setAttempt] = React.useState(0);
  const [status, setStatus] = React.useState('checking');
  const cookies = React.useMemo(() => new Cookies(), []);
  const token = cookies.get("token");

  React.useEffect(() => {
    let active = true;

    if (!token) {
      setStatus('anonymous');
      return () => { active = false; };
    }

    setStatus('checking');
    axios.get(`${config.SERVER}/api/auth/session`, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    })
      .then(() => {
        if (active) setStatus('authenticated');
      })
      .catch((error) => {
        if (!active) return;
        if (error.response?.status === 401) {
          removeAuthCookie(cookies, 'token');
          removeAuthCookie(cookies, 'user');
          removeAuthCookie(cookies, 'IdVendedor');
          window.sessionStorage.setItem('almafer.sessionExpired', 'true');
          setStatus('expired');
        } else {
          setStatus('unavailable');
        }
      });

    return () => { active = false; };
  }, [attempt, cookies, token]);

  if (status === 'checking') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 4 }} role="status">
        <CircularProgress size={24} />
        Comprobando tu sesión…
      </Box>
    );
  }

  if (status === 'unavailable') {
    return (
      <Alert severity="warning" sx={{ width: '100%', my: 3 }}>
        <AlertTitle>No pudimos comprobar tu sesión</AlertTitle>
        Revisá la conexión e intentá nuevamente.
        <Box sx={{ mt: 1 }}>
          <Button variant="outlined" color="inherit" onClick={() => setAttempt(value => value + 1)}>
            Reintentar
          </Button>
        </Box>
      </Alert>
    );
  }

  if (status === 'authenticated') {
    return <Outlet />;
  }

  const loginPath = status === 'expired'
    ? '/login?reason=session-expired'
    : '/login';
  return <Navigate to={loginPath} replace state={{ from: location }} />;
}

export default ProtectedRoutes
